/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Unlock_TextInputs */



/**
* | output |
* | --- |
* | "Do you want to unlock \"{name}\"? This will allow others to modify it." |
*
* @param {Explorer_Info_Unlock_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlock_text = /** @type {((inputs: Explorer_Info_Unlock_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlock_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Voulez-vous deverrouiller "${i?.name}" ? Cela permettra aux autres de le modifier.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" entsperren? Dadurch können andere es bearbeiten.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Vuoi sbloccare "${i?.name}"? Questo permetterà ad altri di modificarlo.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы хотите разблокировать "${i?.name}"? Это позволит другим пользователям изменять его.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Quieres desbloquear "${i?.name}"? Esto permitirá que otros puedan modificarlo.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您是否要解锁“${i?.name}”？这将允许其他人对其进行修改。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」のロックを解除しますか？これにより、他のユーザーが変更できるようになります。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप "${i?.name}" को अनलॉक करना चाहते हैं? इससे दूसरों को इसे संशोधित करने की अनुमति मिल जाएगी।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Deseja desbloquear "${i?.name}"? Isso permitirá que outros o modifiquem.`)
	return /** @type {LocalizedString} */ (`Do you want to unlock "${i?.name}"? This will allow others to modify it.`)
});